import actions from '@/core/store/ata/documento/actions'
import state from '@/core/store/ata/documento/state'
import mutations from '@/core/store/ata/documento/mutations'

export default {
	actions,
	state,
	mutations,
}
